import { Radio } from 'antd';
import { CustomImage } from '@src/components';
import '@src/styles/cardOrder/creditCards.scss';
import { bankCodeIcon, cardTypeIcon } from '@src/utils/utils';

const CreditCards = ({ cardItem, tCar = false, onClickCard, selectedStoredCard }) => {
  const bankIcon = bankCodeIcon(cardItem?.bankCode);
  const cardIcon = cardTypeIcon(cardItem?.cardType);

  if (tCar) {
    return (
      <button
        style={{
          backgroundColor: 'transparent',

          borderWidth: 0,
        }}
        id={`ticketRestaurant-balanceUpload-balanceInformation-orderType-${cardItem?.cardToken}`}
        onClick={() => onClickCard(cardItem?.cardToken)}
        key={cardItem?.id}
      >
        <div
          className="credit-card-item"
          style={{
            borderWidth: selectedStoredCard === cardItem?.cardToken ? 2 : 0,
            borderColor: selectedStoredCard === cardItem?.cardToken ? '#00a483' : 'transparent',
          }}
        >
          <CustomImage className="bank-card-logo" src={bankIcon} />
          {/* <CustomImage className='bank-credit-card-logo' src={creditCardBankLogo} /> */}
          <div className="card-number">{cardItem?.maskedCardNumber}</div>
          <div className="card-info">
            <CustomImage className="card-type-logo" src={cardIcon} />
          </div>
        </div>
      </button>
    );
  }
  return (
    <Radio
      id={`ticketRestaurant-balanceUpload-balanceInformation-orderType-${cardItem?.cardToken}`}
      value={cardItem?.cardToken}
      key={cardItem?.id}
    >
      <div className="credit-card-item">
        <CustomImage className="bank-card-logo" src={bankIcon} />
        {/* <CustomImage className='bank-credit-card-logo' src={creditCardBankLogo} /> */}
        <div className="card-number">{cardItem?.maskedCardNumber}</div>
        <div className="card-info">
          <CustomImage className="card-type-logo" src={cardIcon} />
        </div>
      </div>
    </Radio>
  );
};

export default CreditCards;
